// components/Billetera.jsx
import React, {useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import axios from 'axios';
//import { FaEnvelope, FaPhone, FaWhatsapp, FaCcPaypal, FaBitcoin } from 'react-icons/fa';
import JEBlue from '../assets/img/moneda-JE.png';
import USD from '../assets/img/usd.png';
import ReloadWallet from './ReloadWallet';
import OrderWallet from './OrderWallet';
import Pay from './Pay';
import CheckBalance from './CheckBalance';



const CardContainer1 = styled.div`
  background: linear-gradient(to bottom right, #333, #555);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 20px;
  width: 45%;
  margin: 47px;
  border: 1px solid #444;
  border-radius: 5px;
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${JEBlue});
    background-size: 130px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.05;
    z-index: -1;
  }
`;

const CardContainer2 = styled.div`
  background: linear-gradient(to bottom right, #333, #555);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 20px;
  width: 80%;
  margin: 50px;
  border: 1px solid #444;
  border-radius: 5px;
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.1);
  
`;



const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
 // margin-bottom: 10px;
  margin-top: -7px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
`;

const BalanceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
`;

const BalanceText = styled.span`
  font-size: 14px;
  color: #999;
  margin-bottom: 2px;
`;

const ImageContainer = styled.div`
  width: 100px;
  height: 70px;
  margin-right: 10px;
  img {
    width: 80%;
    height: 80%;
    object-fit: contain;
  }
`;

const BilleteraContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: -40px;
justify-content: space-between; // Cambia esto para distribuir el espacio entre las columnas
`;

const ColumnContainer1 = styled.div`
  width: 50%; // Establece el ancho en 50%
  display: flex; // Añade display: flex
  flex-direction: column; // Añade flex-direction: column
`;

// const TransactionContainer = styled.div`
//   margin-top: 20px; // Añade un margen superior
// `;

const ColumnContainer2 = styled.div`
 // width: 50%; // Establece el ancho en 50%
  margin-left: 0; // Elimina el margen izquierdo
`;


const Column1 = styled.div`
  margin-right: 0%;
`;

const Column2 = styled.div`
margin-right: 0%;
`;


const Item = styled.li`
  background-color: rgba(255, 255, 255, 0.05);
  font-size: 12px;
   padding: 7px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
`;


const Billetera = ({ isLoggedIn, role, token, showReloadWallet, showPay, orderWallet, showChequedBalance, userId, document, celular, email }) => {
  //const [selectedCurrency, setSelectedCurrency] = useState('binance');
  // const [currencyData, setCurrencyData] = useState(null);
  const [balance, setBalance] = useState(0);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch('https://pydolarve.org/api/v1/dollar?page=criptodolar', {
  //         mode: 'no-cors'
  //     });
  //       setCurrencyData(response.data.monitors);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const fetchBalance = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/balance/${userId}`);
      setBalance(response.data.balance);
    } catch (error) {
      console.error('Error fetching balance:', error);
    }
  }, [userId]); // Add userId as a dependency
  
  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]); // fetchBalance is now stable

  // const handleCurrencyChange = (event) => {
  //   setSelectedCurrency(event.target.value);
  // };

  // if (!currencyData) {
  //   return <div>Loading...</div>;
  // }

  return (
    <BilleteraContainer>
      <ColumnContainer1>
      <CardContainer1>
          <Header>
            <Title>Estado de tu Billetera</Title>
            <BalanceText>Saldo actual:</BalanceText>
          </Header>
          <BalanceContainer>
          <ImageContainer>
            <img src={USD} alt="" />
          </ImageContainer>
            <span>{balance} USD</span>
          </BalanceContainer>
        </CardContainer1>
        {/* <TransactionContainer>
          <TransactionList>
            <TransactionItem>Recarga de $500</TransactionItem>
            <TransactionItem>Transferencia de $200</TransactionItem>
          </TransactionList>
        </TransactionContainer> */}
        {showReloadWallet ? (
          <ReloadWallet 
          isLoggedIn={isLoggedIn} 
          role={role} token={token} 
          document={document} 
          celular={celular}
          onPaymentSuccess={fetchBalance} // Pasa la función al componente Pay 
          />
        ) : showPay ? (
          <Pay 
            isLoggedIn={isLoggedIn} 
            role={role} 
            token={token} 
            document={document} 
            celular={celular} 
            email={email} 
            userId={userId}
            onPaymentSuccess={fetchBalance} // Pasa la función al componente Pay 
          />
        ) : orderWallet ? (
          <OrderWallet 
            isLoggedIn={isLoggedIn} 
            role={role} 
            token={token} 
            document={document} 
            celular={celular} 
            email={email} 
            userId={userId}
            onPaymentSuccess={fetchBalance} // Pasa la función al componente Pay 
          />
        ) : showChequedBalance ? (
          <CheckBalance 
            isLoggedIn={isLoggedIn} 
            role={role} 
            token={token} 
            document={document} 
            celular={celular} 
            email={email} 
            userId={userId}
            onPaymentSuccess={fetchBalance} // Pasa la función al componente Pay 
          />
        ) : null
        }
      </ColumnContainer1>
      <ColumnContainer2>
      <CardContainer2>
          <Header>
          <Title>Información de Contacto y Pagos</Title>
          </Header>
          <BalanceText>Contactanos para realizar tus pagos</BalanceText>
    
          <BalanceContainer>
          <Column1>
              <h6>Información de Contacto</h6>
            <Item>C.V.: 20.810.778</Item>
            <Item>correo: jesus.e.elias.s@gmail.com</Item>
            <Item>celular: +584245989356</Item>
            <Item>banco: Mercantil</Item>
            <Item>n cuenta: 01543434030430404034</Item>
            </Column1>

            <Column2>
              <h6>Métodos de Pago</h6>
              <Item>Binance</Item>
              <Item>Paypal</Item>
              <Item>Artim</Item>
              <Item>Pago Movil</Item>
              <Item>Transferencia Bancaria</Item>
            </Column2>
          </BalanceContainer>
        </CardContainer2>

        {/* <CardContainer3>
          <Header>
            <Title>Cambia de moneda:</Title>
          </Header>
         
        </CardContainer3> */}
        
      </ColumnContainer2>


    </BilleteraContainer>
  );
};

export default Billetera;